<template>
  <div class="view view-history">
    <div class="container">
      <div class="games-log">
        <h3>Latest games</h3>
        <ul>
          <li v-for="game in sortedGames" v-if="userById(game.players.player1) && userById(game.players.player2)">
            <span>{{userById(game.players.player1).first_name}} vs {{userById(game.players.player2).first_name}} - {{humanDate(game.timestamp)}}, </span>
            <span v-if="game.winner">Winner: {{userById(game.winner).first_name}}</span>
            <span>
                  <button class="button small white" v-if="game.winner" @click="deleteGame(game)">Delete</button>
                  <span v-else>game in progress</span>
                </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import {db} from '@/utils/firebase'
  import moment from 'moment'

  export default {
    firebase: {
      users: db.ref('users'),
      games: db.ref('games'),
      totalGames: db.ref('total_games')
    },
    computed: {
      sortedGames () {
        return this.games.sort(function(a, b) {
          return b.timestamp - a.timestamp
        })
      }
    },
    methods: {
      humanDate (timestamp) {
        return moment(timestamp).format('DD/MM, kk:mm')
      },
      userById (id) {
        return this.users.find(user => user['.key'] === id)
      },
      deleteGame (game) {
        // remove game
        this.$firebaseRefs.games.child(game['.key']).remove()
        this.$firebaseRefs.users.child(game.players.player1).child('results').child(game['.key']).remove()
        this.$firebaseRefs.users.child(game.players.player2).child('results').child(game['.key']).remove()
        // update total games
        this.$firebaseRefs.totalGames.transaction(function (total) {
          return (total || 0) - 1
        })
      }
    }
  }

</script>

<style lang="scss" scoped>

  .view-history {
    color: $color-white;
    padding-top: 5rem;

    @include respond-to(medium) {
      padding-top: 10rem;
    }

  }

  .games-log {

    h3 {
      font-family: $font-primary;
      font-size: 3rem;
      font-weight: 900;
      text-transform: uppercase;
      text-align: center;
      letter-spacing: 5px;
      padding-bottom: 2rem;
    }

    ul {
      @include reset-list;
      height: 80vh;
      padding: 2rem;
      text-align: center;
      background-color: $color-primary;
      border: 20px solid $color-white;
      overflow-y: auto;

      li {
        display: flex;
        margin-bottom: 2rem;

        span {
          width: (100% / 3);
        }

        span:last-of-type {
          text-align: right;
        }

      }

    }

  }


</style>



// WEBPACK FOOTER //
// src/components/History.vue